import { ChevronRight } from "@mui/icons-material";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import { Theme, styled, useTheme } from "@mui/material/styles";
import AppLogo from "components/AppLogo";
import CheckInQrCode from "components/CheckInQrCode";
import Partners from "components/Partners";
import { ROUTES } from "helpers/routes";
import * as React from "react";
import { ReactNode } from "react";
import { Outlet } from "react-router-dom";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const BaseLayout: React.FC<{
  children?: ReactNode;
  header?: ReactNode;
  additional?: ReactNode;
  isHome?: boolean;
  showRightLogo?: boolean;
}> = ({ children, header, isHome = false, showRightLogo = true }) => {
  const theme: Theme = useTheme();

  React.useEffect(() => {
    window.addEventListener("resize", () => {
      const rootElement = document.documentElement;
      rootElement.style.setProperty(
        "--screen-height",
        `${window.innerHeight}px`
      );
    });
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGap: theme.spacing(1),
        background: "url('/img/bg.png') no-repeat center center fixed",
        backgroundSize: "cover",
      }}
    >
      {showRightLogo && (
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            height: "var(--screen-height)",
            pointerEvents: "none",
            position: "fixed",
          }}
        >
          <img
            alt=""
            src="/img/logo.png"
            height="100%"
            width="auto"
            style={{ position: "absolute", pointerEvents: "none" }}
          />
        </Box>
      )}

      {isHome && (
        <>
          <Box
            sx={{
              width: "100%",
              display: { xs: "flex", md: "none" },
              justifyContent: "center",
              paddingTop: theme.spacing(10),
            }}
          >
            <AppLogo />
          </Box>

          <Partners />

          <Box
            sx={{
              gap: 2,
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              minHeight: "var(--screen-height)",
              paddingInline: theme.spacing(4),
              paddingBottom: theme.spacing(6),
              position: "fixed",
              top: 0,
              left: 0,
              height: "100%",
              display: { xs: "none", md: "flex" },
            }}
          >
            <CheckInQrCode />
            <Button
              href={ROUTES.CHECK_IN}
              fullWidth
              variant="white"
              endIcon={<ChevronRight />}
            >
              iPad Check-in
            </Button>
            <Button
              fullWidth
              variant="outlined-white"
              endIcon={<ChevronRight />}
              href={ROUTES.UPDATE_MY_INFO}
            >
              Update my info
            </Button>
          </Box>
        </>
      )}

      {header}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          position: "relative",
          minHeight: "var(--screen-height)",
          paddingY: theme.spacing(5),
          paddingX: theme.spacing(4),
          paddingTop: { xs: theme.spacing(6), md: theme.spacing(10) },
          marginLeft: isHome ? { md: "384px" } : 0,
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {children}
        <DrawerHeader />
        <Outlet />
      </Box>
    </Box>
  );
};

export default BaseLayout;
